import { defineStore } from "pinia";

export const useCreateStore = defineStore("create-store", {
  state: () => ({
    orgId: 0,
    activePublications: [],
    draftPublications: [],
    collaboratingPublications: [],
    dynamicApps: {},
    isLoadingCreatePublication: false,
    isLoadingCreateApp: false,
  }),
  getters: {
    publicationsMap() {
      return this.publications.reduce((map, publication) => {
        map[publication.publication_id] = publication;
        return map;
      }, {});
    },
    publications() {
      return [
        ...this.activePublications,
        ...this.draftPublications,
        ...this.collaboratingPublications,
      ];
    },
  },
  actions: {
    createApp(name, description, callback = () => {}) {
      this.isLoadingCreateApp = true;
      this.apiPost("/dynamic-apps", {
        app_title: name,
        app_description: description,
        app_icon: "tdesign:app",
      }, response => {
        callback(Object.values(response.configsToUpdate)[0]);
      }, () => {}, () => {
        this.isLoadingCreateApp = false;
      });
    },
    createPublication(
      name,
      description,
      templatePublicationId,
      theme = 0,
      accessControlFeatures,
      callback = () => {
      },
    ) {
      this.isLoadingCreatePublication = true;
      this.apiPost(`/api/v1/publication/org/${this.orgId}`, {
        name,
        description,
        template_publication_id: templatePublicationId,
        theme,
        access_control_features: accessControlFeatures,
      }, data => {
        callback(data);
      }, () => {
      }, () => {
        this.isLoadingCreatePublication = false;
      });
    },
  },
});
